import { LoadingState } from "../../../type/loading-state";

export const startGlobalLoadingDispatch = (state: LoadingState) => {
  state.globalLoading = true;
  state.isDim = true
};
